import { SEO } from '../components/seo/SEO';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/hero/Hero';
import { Services } from '../components/services/Services';
import { PackagesPreview } from '../components/packages/PackagesPreview';
import { ToolsPreview } from '../components/tools/ToolsPreview';
import { Stats } from '../components/stats/Stats';
import { Testimonials } from '../components/testimonials/Testimonials';
import { FAQ } from '../components/faq/FAQ';
import { FinalCTA } from '../components/cta/FinalCTA';
import { Features } from '../components/features/Features';
import { BlogPreview } from '../components/blog/BlogPreview';

export function Home() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "MSMECenter",
    "description": "India's all-in-one digital platform for MSMEs. Start, manage, and grow your business.",
    "url": "https://msmecenter.com",
    "logo": "https://msmecenter.com/logo.png",
    "sameAs": [
      "https://facebook.com/msmecenter",
      "https://twitter.com/msmecenter",
      "https://linkedin.com/company/msmecenter"
    ]
  };

  return (
    <>
      <SEO
        title="MSMECenter – India's Most Trusted MSME Platform | Start, Grow & Scale"
        description="India's all-in-one digital platform for MSMEs. GST registration, business loans, compliance, digital marketing, and more. Trusted by 10,000+ businesses."
        canonical="https://msmecenter.com"
        ogImage="https://msmecenter.com/og-image.jpg"
        schema={schema}
      />
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <PackagesPreview />
        <ToolsPreview />
        <Features />
        <Testimonials />
        <BlogPreview />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}